import { render, staticRenderFns } from "./TagAutocomplete.vue?vue&type=template&id=a9b9dbf2&"
import script from "./TagAutocomplete.vue?vue&type=script&lang=js&"
export * from "./TagAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports